"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "damages.docsInsurer";
  var componentName = "docsInsurer";

  var bindings = {
    resolve: "<?",
    damage: "<?"
  };

  var templateUrl = "app/pages/damages/docsInsurer/docsInsurer.component.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $timeout, $window, DamagesService, VehiclesService, UsersService, CustomListsService, ModalService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$window = $window;

      this.DamagesService = DamagesService;
      this.UsersService = UsersService;
      this.VehiclesService = VehiclesService;
      this.CustomListsService = CustomListsService;

      this.ModalService = ModalService;
    }

    _createClass(Controller, [{
      key: "update",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  _context.prev = 1;
                  _context.next = 4;
                  return this.DamagesService.updateAttributesById(this.damage._id, {
                    docs: this.damage.docs
                  });

                case 4:
                  _context.next = 6;
                  return this.DamagesService.customPost("sendToInsurer", {
                    damageId: this.damage._id,
                    templateName: "damage.docsInsurerEdi"
                  });

                case 6:
                  response = _context.sent;

                  if (response && response.success === true) {
                    Notiflix.Notify.success("Envoi réussi");
                  } else {
                    Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + response.info);
                  }

                  Notiflix.Loading.remove();
                  this.close();
                  _context.next = 16;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](1);

                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context.t0.message);
                  Notiflix.Loading.remove();

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 12]]);
        }));

        function update() {
          return _ref.apply(this, arguments);
        }

        return update;
      }()
    }, {
      key: "cancel",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var reason, textarea, label, div, confirmCancel, response;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  reason = "";
                  textarea = document.createElement("textarea");

                  textarea.innerHTML = reason ? reason : "";
                  textarea.className = "form-control";
                  textarea.onchange = function selectChanged(e) {
                    reason = e.target.value;
                  };

                  label = document.createElement("label");

                  label.innerHTML = "Raison :";

                  div = document.createElement("div");

                  div.appendChild(label);
                  div.appendChild(textarea);

                  _context2.next = 12;
                  return swal({
                    title: "Attention : Etes-vous sur de vouloir transmettre un email d'annulation ?",
                    content: {
                      element: div
                    },
                    icon: "warning",
                    dangerMode: true,
                    buttons: {
                      cancel: "Non",
                      confirm: "Oui"
                    }
                  });

                case 12:
                  confirmCancel = _context2.sent;

                  if (!confirmCancel) {
                    _context2.next = 28;
                    break;
                  }

                  _context2.prev = 14;

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  _context2.next = 18;
                  return this.DamagesService.customPost("sendToInsurer", {
                    damageId: this.damage._id,
                    templateName: "damage.cancelEdi"
                  });

                case 18:
                  response = _context2.sent;

                  if (response && response.success === true) {
                    Notiflix.Notify.success("Envoi réussi");
                  } else {
                    Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + response.info);
                  }
                  Notiflix.Loading.remove();
                  this.close();
                  _context2.next = 28;
                  break;

                case 24:
                  _context2.prev = 24;
                  _context2.t0 = _context2["catch"](14);

                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context2.t0.message);
                  Notiflix.Loading.remove();

                case 28:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[14, 24]]);
        }));

        function cancel() {
          return _ref2.apply(this, arguments);
        }

        return cancel;
      }()
    }, {
      key: "send",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log("send...");
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  _context3.prev = 2;
                  _context3.next = 5;
                  return this.DamagesService.customPost("sendToInsurer", {
                    damageId: this.damage._id,
                    templateName: "damage.edi"
                  });

                case 5:
                  response = _context3.sent;

                  if (response && response.success === true) {
                    Notiflix.Notify.success("Envoi réussi");
                  } else {
                    Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + response.info);
                  }
                  Notiflix.Loading.remove();
                  this.close();
                  _context3.next = 15;
                  break;

                case 11:
                  _context3.prev = 11;
                  _context3.t0 = _context3["catch"](2);

                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context3.t0.message);
                  Notiflix.Loading.remove();

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[2, 11]]);
        }));

        function send() {
          return _ref3.apply(this, arguments);
        }

        return send;
      }()
    }, {
      key: "close",
      value: function close() {
        if (this.$scope.$parent) {
          this.$scope.$parent.$close();
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(this.resolve && this.resolve.params)) {
                    _context4.next = 37;
                    break;
                  }

                  this.damage = this.resolve.params.damage;

                  console.log("docs", this.damage.docs);

                  _context4.next = 5;
                  return this.UsersService.getById(this.damage.driverId.replace("$", ""));

                case 5:
                  this.driver = _context4.sent;
                  _context4.next = 8;
                  return this.UsersService.getName(this.driver);

                case 8:
                  this.driver.name = _context4.sent;
                  _context4.next = 11;
                  return this.VehiclesService.getById(this.damage.vehicleId.replace("$", ""));

                case 11:
                  this.vehicle = _context4.sent;
                  _context4.next = 14;
                  return this.VehiclesService.getName(this.vehicle);

                case 14:
                  this.vehicle.name = _context4.sent;


                  this.docs = [];
                  this.docsNotSent = [];
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context4.prev = 20;
                  for (_iterator = this.damage.docs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    doc = _step.value;

                    if (doc.insurerTransmissionDate) {
                      this.docs.push(doc);
                    } else {
                      this.docsNotSent.push(doc);
                    }
                  }
                  _context4.next = 28;
                  break;

                case 24:
                  _context4.prev = 24;
                  _context4.t0 = _context4["catch"](20);
                  _didIteratorError = true;
                  _iteratorError = _context4.t0;

                case 28:
                  _context4.prev = 28;
                  _context4.prev = 29;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 31:
                  _context4.prev = 31;

                  if (!_didIteratorError) {
                    _context4.next = 34;
                    break;
                  }

                  throw _iteratorError;

                case 34:
                  return _context4.finish(31);

                case 35:
                  return _context4.finish(28);

                case 36:
                  this.$timeout(function () {}, 0);

                case 37:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[20, 24, 28, 36], [29,, 31, 35]]);
        }));

        function $onInit() {
          return _ref4.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    controller: Controller
  });
})();